module.exports = __webpack_public_path__ + "static/img/reject.76e075b6.png";